let items = [
  {
    id: 0,
    title: 'Google Address Autocomplete',
    timestamp: '10/8/2015, 10:55:52 PM',
    type: 'forms',
    description:
      'An autocompleting address field that reduces form friction and improves user experience.',
    link: 'https://landingpage.noahmatsell.ca/google-address-autocomplete/',
    tags: ['form', 'javascript', 'maps', 'google']
  },
  {
    id: 1,
    title: 'Google Doc Embed',
    timestamp: '10/5/2015, 10:20:46 AM',
    type: 'layout',
    description:
      'Different techniques for embedding a Google Drive PDF on a landing page.',
    link: 'https://landingpage.noahmatsell.ca/drive-pdf-embed/',
    tags: ['pdf', 'embed', 'content', 'google']
  },
  {
    id: 2,
    title: 'Dynamic Month Insertion',
    timestamp: '10/8/2015, 3:01:32 PM',
    type: 'design',
    description:
      'Insert current month to improve the relevance of landing page copy.',
    link: 'https://landingpage.noahmatsell.ca/insert-month/',
    tags: ['javascript', 'date', 'content']
  },
  {
    id: 3,
    title: 'Dynamic Visitor Data',
    timestamp: '11/5/2015, 3:24:23 PM',
    type: 'design',
    description:
      'Use Targeting Monkey to personalize page content with user location and environment.',
    link: 'https://landingpage.noahmatsell.ca/targeting-monkey-test/',
    tags: ['javascript', 'content', 'geotargeting']
  },
  {
    id: 4,
    title: 'Show Lightbox on Load',
    timestamp: '10/23/2015, 10:05:50 AM',
    type: 'layout',
    description:
      'Display a lightbox on a landing page after a defined period of time.',
    link: 'https://landingpage.noahmatsell.ca/lightbox-onload/',
    tags: ['javascript', 'content', 'layout']
  },
  {
    id: 5,
    title: 'Conditional Form Field',
    timestamp: '12/22/2015, 7:51:42 PM',
    type: 'forms',
    description:
      'Show a hidden field if a checkbox option is selected on your form.',
    link: 'https://landingpage.noahmatsell.ca/conditional-fields/',
    tags: ['form', 'fields', 'conditional', 'javascript']
  },
  {
    id: 6,
    title: 'Sliding Side Menus',
    timestamp: '12/16/2015, 11:33:55 AM',
    type: 'layout',
    description: 'A vertical sidebar menu that appears on button click.',
    link: 'https://landingpage.noahmatsell.ca/sliding-side-menu/',
    tags: ['javascript', 'content', 'layout', 'animation']
  },
  {
    id: 7,
    title: 'Hover Effects',
    timestamp: '7/22/2015, 8:56:24 PM',
    type: 'design',
    description: 'Various hover effects and how to use them with Unbounce!',
    link: 'http://unbouncepages.com/link-hover/',
    tags: ['css', 'design']
  },
  {
    id: 8,
    title: 'Back to Top Button',
    timestamp: '1/6/2016, 9:57:19 PM',
    type: 'layout',
    description:
      'A fading back to top button that appears as users scroll down the landing page.',
    link: 'https://landingpage.noahmatsell.ca/back-to-top-1/',
    tags: ['css', 'layout']
  },
  {
    id: 9,
    title: 'Show Elements Effect',
    timestamp: '1/10/2016, 9:34:51 PM',
    type: 'layout',
    description: 'Show page elements with a fading animation.',
    link: 'https://landingpage.noahmatsell.ca/slow-show/',
    tags: ['javascript', 'layout', 'content']
  },
  {
    id: 10,
    title: 'Fading Navigation Bar',
    timestamp: '1/11/2016, 11:36:58 AM',
    type: 'layout',
    description:
      'A navigation bar that fades in when a visitor starts scrolling.',
    link: 'https://landingpage.noahmatsell.ca/fading-navigation-bar/',
    tags: ['javascript', 'content']
  },
  {
    id: 11,
    title: 'CSS Animations',
    timestamp: '1/15/2016, 9:19:04 AM',
    type: 'layout',
    description:
      'Emphasize the elements on your landing page with simple, beautiful animations.',
    link: 'https://landingpage.noahmatsell.ca/animations-1',
    tags: ['javascript', 'layout', 'content', 'animation']
  },
  {
    id: 12,
    title: 'Count Up Animation',
    timestamp: '5/13/2016, 11:43:44 AM',
    type: 'layout',
    description: 'Animation of a number counting up...',
    link: 'https://landingpage.noahmatsell.ca/count-up-animation/',
    tags: ['javascript', 'content']
  },
  {
    id: 13,
    title: 'Focus and Glow',
    timestamp: '7/7/2016, 11:05:26 PM',
    type: 'forms',
    description:
      'Add focus and glowing effet to first form field automatically.',
    link: 'https://landingpage.noahmatsell.ca/focus-and-glow/',
    tags: ['javascript', 'content', 'form']
  },
  {
    id: 14,
    title: 'Form Field Masking',
    timestamp: '6/23/2016, 9:43:50 AM',
    type: 'forms',
    description:
      'Ensure standardized, valid, and consistent data is sumbitted on your landing pages',
    link: 'https://landingpage.noahmatsell.ca/form-field-masking/',
    tags: ['javascript', 'form', 'fields']
  },
  {
    id: 15,
    title: 'Typed Text Effect',
    timestamp: '10/3/2016, 1:35:15 PM',
    type: 'layout',
    description:
      'A cool effect that types out words or phrases dynamically on your landing page.',
    link:
      'https://community.unbounce.com/t/how-to-create-a-typed-text-effect-in-unbounce/',
    tags: ['javascript', 'content', 'animation']
  },
  {
    id: 16,
    title: 'On-scroll Animations',
    timestamp: '3/1/2016, 4:17:25 PM',
    type: 'layout',
    description: 'Animate your page elements on-scroll.',
    link:
      'https://community.unbounce.com/t/tips-scripts-on-scroll-animations/3221',
    tags: ['javascript', 'animation']
  },
  {
    id: 17,
    title: 'Collapsible Page Section',
    timestamp: '1/18/2017, 1:07:38 PM',
    type: 'layout',
    description:
      'Create a page section that vertically collapses and expands to show and hide page content.',
    link:
      'https://community.unbounce.com/t/how-to-create-a-collapsible-page-section/4408',
    tags: ['javascript', 'layout']
  },
  {
    id: 18,
    title: 'Sticky Video Widget',
    timestamp: '11/14/2016, 7:45:26 PM',
    type: 'layout',
    description:
      'Turns a regular video into a smaller video that follows the visitor as they scroll.',
    link:
      'https://community.unbounce.com/t/how-to-add-a-sticky-video-widget/4085',
    tags: ['javascript', 'layout', 'video']
  },
  {
    id: 19,
    title: 'Mobile Hamburger Menu',
    timestamp: '2/29/2016, 1:52:11 PM',
    type: 'layout',
    description: 'Create a hamburger menu for your mobile enabled pages.',
    link:
      'https://community.unbounce.com/t/tips-scripts-mobile-hamburger-navigation-menu/3289',
    tags: ['javascript', 'layout', 'navigation']
  },
  {
    id: 20,
    title: 'Conversational Forms',
    timestamp: '3/4/2017, 11:20:02 PM',
    type: 'forms',
    description:
      'Breathe some life into your forms with this chat-like solution.',
    link:
      'https://community.unbounce.com/t/create-conversational-forms-in-unbounce/4988',
    tags: ['javascript', 'form']
  },
  {
    id: 21,
    title: 'Countdown Timer',
    timestamp: '12/15/2016, 2:58:46 PM',
    type: 'design',
    description: 'Create a sense of urgency with a countdown timer.',
    link:
      'https://community.unbounce.com/t/how-to-add-a-countdown-timer-in-unbounce/4777',
    tags: ['javascript', 'animation', 'content']
  },
  {
    id: 22,
    title: 'Angled Page Sections',
    timestamp: '7/16/2017, 9:03:46 PM',
    type: 'layout',
    description:
      'A subtle way to indicate that more content exists … and prompt visitors to scroll down to find it.',
    link:
      'https://community.unbounce.com/t/how-to-create-angled-page-sections-aka-false-bottoms/5836',
    tags: ['javascript', 'layout']
  },
  {
    id: 23,
    title: 'Confetti Background',
    timestamp: '8/3/2017, 11:11:23 AM',
    type: 'design',
    description:
      'inject a little ‘celebration’ into your post-click experience when visitors submit your form.',
    link:
      'https://community.unbounce.com/t/how-to-add-an-animated-confetti-background-on-form-submit/5968',
    tags: ['javascript', 'design']
  },
  {
    id: 24,
    title: 'Custom Dropdown Menu Items',
    timestamp: '2/1/2017, 1:42:24 PM',
    type: 'forms',
    description:
      'Dynamically add dropdown menu items from external lists or APIs.',
    link: 'https://landingpage.noahmatsell.ca/dynamic-dropdown-list/',
    tags: ['javascript', 'form', 'fields']
  },
  {
    id: 25,
    title: '100% Height Page Section',
    timestamp: '2/23/2017, 4:14:46 PM',
    type: 'layout',
    description: 'Make your page section fullscreen--at any browser height!',
    link: 'https://landingpage.noahmatsell.ca/full-height-section/',
    tags: ['javascript', 'layout', 'design']
  },
  {
    id: 26,
    title: 'Device Sniffer',
    timestamp: '1/27/2016, 11:13:33 AM',
    type: 'forms',
    description:
      "Detect the visitor's device and add it to form submissions for better segmentation!",
    link: 'https://landingpage.noahmatsell.ca/mobile-sniffing/',
    tags: ['javascript', 'form']
  },
  {
    id: 27,
    title: 'Advanced Email Validation',
    timestamp: '4/5/2017, 2:22:08 PM',
    type: 'forms',
    description:
      "Use Mailgun's API for more sophisticated email validation on your forms.",
    link: 'https://landingpage.noahmatsell.ca/mailgun-email-validator/',
    tags: ['javascript', 'form', 'validation']
  },
  {
    id: 28,
    title: 'Advanced Text Shadows',
    timestamp: '6/14/2017, 11:26:31 AM',
    type: 'design',
    description: 'These are some next level, beautiful text shadows.',
    link: 'https://landingpage.noahmatsell.ca/advanced-text-shadows/',
    tags: ['css', 'text', 'design']
  },
  {
    id: 29,
    title: 'Auto Adjusting Date/Time',
    timestamp: '6/16/2017, 11:27:38 AM',
    type: 'layout',
    description:
      "Set your date/time once and have it automatically update based on the visitor's timezone.",
    link: 'https://landingpage.noahmatsell.ca/dynamic-timezone-date/',
    tags: ['javascript']
  },
  {
    id: 30,
    title: 'Better Mobile Inputs',
    timestamp: '2/7/2017, 2:07:23 PM',
    type: 'forms',
    description:
      "Style your form inputs so that they're more mobile friendly and easy to use.",
    link: 'https://landingpage.noahmatsell.ca/mobile-form-controls/',
    tags: ['javascript', 'form', 'inputs', 'css']
  },
  {
    id: 31,
    title: 'Vertically Split Page Section',
    timestamp: '11/30/2017, 4:59:01 PM',
    type: 'layout',
    description:
      'Create a page section that is split vertically, allowing you to add content with clarity AND an impactful background.',
    link: 'https://landingpage.noahmatsell.ca/vertical-slant/',
    tags: ['css', 'layout']
  },
  {
    id: 32,
    title: 'Video Interaction Effects',
    timestamp: '9/18/2017, 12:30:30 PM',
    type: 'design',
    description:
      'Trigger custom actions on your page based on video user interactions.',
    link: 'https://landingpage.noahmatsell.ca/video-interaction-offers/',
    tags: ['javascript', 'video', 'interaction']
  },
  {
    id: 33,
    title: 'Particle Background',
    timestamp: '11/2/2017, 4:30:40 PM',
    type: 'design',
    description:
      'Create a background containing floating, interactive, geometric shapes.',
    link: 'https://landingpage.noahmatsell.ca/particles/',
    tags: ['javascript', 'animation']
  },
  {
    id: 34,
    title: 'Scroll Progress Widget',
    timestamp: '10/18/2017, 3:44:17 PM',
    type: 'design',
    description: 'A widget that displays your scrolling progress',
    link: 'https://landingpage.noahmatsell.ca/scroll-progress/',
    tags: ['css', 'javascript']
  },
  {
    id: 35,
    title: 'Full Height Page Section',
    timestamp: '2/23/2017, 4:14:46 PM',
    type: 'layout',
    description: 'Create a browser section that fills the full browser height.',
    link: 'https://landingpage.noahmatsell.ca/full-height-section/',
    tags: ['css', 'javascript', 'layout']
  },
  {
    id: 36,
    title: 'Box Hover Effects',
    timestamp: '9/11/2018, 7:48:23 PM',
    type: 'design',
    description: 'Add stylish hover effects to boxes on your pages.',
    link: 'https://landingpage.noahmatsell.ca/box-hover-animations/',
    tags: ['css', 'animation']
  },
  {
    id: 37,
    title: '3D Rotating Gallery ',
    timestamp: '3/21/2018, 9:06:39 AM',
    type: 'design',
    description: 'Add a 3d rotating gallery of images to your page.',
    link: 'https://landingpage.noahmatsell.ca/3d-rotating-gallery/',
    tags: ['css', 'javascript', 'animation']
  },
  {
    id: 38,
    title: 'Tilting Element Effect',
    timestamp: '1/29/2018, 10:41:25 AM',
    type: 'design',
    description: 'Add an animated tilted effect to page elements on hover.',
    link: 'https://landingpage.noahmatsell.ca/tilt-effect/',
    tags: ['css', 'animation']
  },
  {
    id: 39,
    title: 'Tabbed Content',
    timestamp: '1/19/2017, 9:18:24 AM',
    type: 'layout',
    description:
      'Separate page content into more digestable pieces using tabbed sections',
    link: 'https://landingpage.noahmatsell.ca/tab-content/',
    tags: ['javascript', 'layout']
  },
  {
    id: 40,
    title: 'Gradient Text',
    timestamp: '9/6/2018, 5:24:48 PM',
    type: 'design',
    description: 'Apply a coloured gradient to select words or paragraphs.',
    link: 'https://landingpage.noahmatsell.ca/gradient-text/',
    tags: ['css', 'design']
  },
  {
    id: 41,
    title: 'Countdown to Date',
    timestamp: '5/4/2017, 10:09:53 AM',
    type: 'design',
    description: 'Show a countdown to a specific date on your pages',
    link: 'https://landingpage.noahmatsell.ca/countdown-to-date/',
    tags: ['javascript', 'animation']
  },
  {
    id: 42,
    title: 'Dot Textured Elements',
    timestamp: '8/23/2018, 9:44:41 AM',
    type: 'design',
    description: 'Add dot textured elements to your pages.',
    link: 'https://landingpage.noahmatsell.ca/dots/',
    tags: ['css', 'design']
  },
  {
    id: 43,
    title: 'Inline Form Errors',
    timestamp: '4/20/2017, 2:29:06 PM',
    type: 'forms',
    description:
      'Display form validation messages inline to provide a more contextual validation experience.',
    link: 'https://landingpage.noahmatsell.ca/inline-error-message/',
    tags: ['javascript', 'forms']
  },
  {
    id: 44,
    title: 'Perspective Warp',
    timestamp: '5/1/2017, 10:51:28 AM',
    type: 'design',
    description: 'Add an animated perspective effect to selected page elements',
    link: 'https://landingpage.noahmatsell.ca/perspective-effect/',
    tags: ['css', 'animation']
  }
];

export default items;



// WEBPACK FOOTER //
// ./src/data/items.js